<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Asset" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-asset-form [asset]="asset" *ngIf="asset"></app-asset-form>
        </form>
      </div>
    </section>
  </div>
</div>
